import axios from "axios";
import { authHeader } from "@/helpers/API/Auth/auth.header.js";
const API_URL = process.env.VUE_APP_ROOT_API;

class OpportunityService {
  //  OPPORTUNITY RELATED APIs

  // Get Opportunity Count
  async getOpportunityCount() {
    return await axios
      .get(API_URL + "crm/lead-opportunity-count", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get Opportunities
  async getOpportunityData(filter = "") {
    return await axios
      .get(API_URL + "crm/lead-opportunity" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Bulk Opportunity Update
  async bulkAddOpp(data) {
    return await axios
      .post(API_URL + "crm/bulk-upload-lead-opportunity", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Create New Opportunity
  async addNewOpportunity(data) {
    return await axios
      .post(API_URL + "crm/lead-opportunity", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // Get detailed Opportunity
  async getDetailedOpportunity(opp_id) {
    return await axios
      .get(API_URL + "crm/lead-opportunity/" + opp_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Update Opportunity
  async updateOpportunity(opp_id, data) {
    return await axios
      .patch(API_URL + "crm/lead-opportunity/" + opp_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // DELETE Opportunity
  async deleteOpportunity(id) {
    return await axios
      .delete(API_URL + "crm/lead-opportunity/" + id, { headers: authHeader() })
      .then((res) => {
        return res.data;
      });
  }

  // Get Opportunities Logs
  async getOpportunityLogs(filter) {
    return await axios
      .get(API_URL + `crm/lead-opportunity-activity${filter}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Create New Opportunity Log
  async addNewOpportunityLog(data) {
    return await axios
      .post(API_URL + "crm/lead-opportunity-activity", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Get detailed Opportunity Log
  async getDetailedOpportunityLog(opp_id) {
    return await axios
      .get(API_URL + "crm/lead-opportunity-activity/" + opp_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // Update Opportunity Log
  async updateOpportunityLog(opp_id, data) {
    return await axios
      .patch(API_URL + "crm/lead-opportunity-activity/" + opp_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}

export default new OpportunityService();
